
<div class="d-flex align-items-center justify-content-center w-100 h-100">
    <div class="text-box">
        <h3>{{ isSignUp ? 'Register online' : 'Log in online'}}</h3>
        <p>Visit the URL below on a computer or mobile device to continue. <span *ngIf="!isSignUp && code"><br>Or scan the QR Code below.</span></p>

        <qrcode *ngIf="!isSignUp && code" [qrdata]="'https://' + config.remoteConfig.base_url + '/watch/' + code" [width]="256" [margin]="1"></qrcode>

        <h4 class="url">{{ config.remoteConfig.base_url }}{{ isSignUp ? '/signup-tv' : '/watch' }}</h4>

        <p *ngIf="isSignUp">Once you’ve signed up, enter your code! </p>

        <h2 class="code">{{code}}</h2>

        <p>{{ countDown }}</p>

    </div>
</div>

